(function () {

  const scrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top');
    const btnScrollTopRect = btnScrollTop.getBoundingClientRect();
    const areIntersecting = (bounds1, bounds2) =>
        bounds1.top < bounds2.bottom && bounds1.bottom > bounds2.top;

    window.addEventListener('scroll', function () {
      if (btnScrollTop) {
        const footer = document.querySelector('.footer');
        const footerRect = footer.getBoundingClientRect();

        if (areIntersecting(footerRect, btnScrollTopRect)) {
          btnScrollTop.classList.add('color-background-3');
        } else {
          btnScrollTop.classList.remove('color-background-3');
        }

        if (scrollY > document.documentElement.clientHeight) {
          btnScrollTop.classList.add('show');
        } else {
          btnScrollTop.classList.remove('show');
        }
      }
    });

    btnScrollTop.onclick = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }

  scrollTop();

  document.addEventListener("shopify:section:load", function () {
    scrollTop();
  })

})()